import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class DynamicReportProxyClass extends ProxyBase {
  searchCompany(params) {
    return this.post('search', params)
  }

  getTemplate(params) {
    return this.get('Template', params)
  }
}

class FinancialAnalysisProxyClass extends ProxyBase {
  getIndicators(params) {
    return this.get('Preferences/Indicators', params)
  }
}

class LibraryProxyClass extends ProxyBase {
  getSearchPortfolio(params) {
    return this.get('Library/SearchPortfolio', params)
  }
}

export const DynamicReportProxy = new DynamicReportProxyClass('DynamicReport/')

export const FinancialAnalysisProxy = new FinancialAnalysisProxyClass(
  'FinancialAnalysis/',
)

export const LibraryProxy = new LibraryProxyClass()
